/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

type Props = {
  thumbnailUrl: string;
  thumbnailAltText: string;
  width?: number;
  height?: number;
  borderRadius?: number;
};

export type CourseItemThumbnailElement = React.ReactElement<Props, typeof CourseItemThumbnail>;

const styles = {
  thumbnail: (borderRadius: number, width: number, height: number) => css`
    border-radius: ${borderRadius}px;
    width: ${width}px;
    height: ${height}px;
    flex-shrink: 0;
    overflow: hidden;
  `,
};

const CourseItemThumbnail = ({ thumbnailUrl, thumbnailAltText, width = 76, height = 53, borderRadius = 6 }: Props) => {
  return (
    <div css={styles.thumbnail(borderRadius, width, height)}>
      <Imgix src={thumbnailUrl} alt={thumbnailAltText} maxWidth={width} imgParams={{ fit: 'fill' }} />
    </div>
  );
};

export default CourseItemThumbnail;
